import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faParking } from "@fortawesome/pro-solid-svg-icons";
import { Dropdown } from "semantic-ui-react";

import { NavigationButton } from "../../../../components";
import { VirtualKeyboard, LAYOUTS } from "../../../../../../components";

import "./OrderEditParkingNote.scss";

class OrderEditParkingNote extends Component {
  state = { parkingNote: this.props.parkingNote || "", selectedSuggestionOrderId: null };

  onChange = parkingNote => {
    this.setState({ parkingNote });
    document.getElementById("OrderEditParkingNote").scrollTop = document.getElementById("OrderEditParkingNote").scrollHeight;
  };

  onChangeDropdown = (_e, { value: selectedSuggestionOrderId }) =>
    this.setState({ selectedSuggestionOrderId }, () => {
      const note = this.props.communication.note_suggestions.find(ns => ns.order === selectedSuggestionOrderId);
      if (note) this.setState({ parkingNote: note.content });
    });

  render() {
    const { parkingNote, selectedSuggestionOrderId } = this.state;
    const { communication, renderLayout, onSave, onGoBack, t } = this.props;

    const noteSuggestionOptions = communication.note_suggestions
      ?.filter(suggestion => suggestion.active)
      ?.map(suggestion => ({
        key: suggestion.order,
        value: suggestion.order,
        text: suggestion.content,
      }));

    const content = (
      <div className="OrderParkingNoteScreen">
        <div className="OrderParkingNoteTitle KioskTitle">
          <FontAwesomeIcon icon={faParking} />
          {t("kiosk_add_parking_location").message || "Add Parking Location"}
        </div>
        {noteSuggestionOptions?.length > 0 && (
          <Dropdown
            className="note-suggestions-dropdown"
            fluid
            selection
            selectOnBlur={false}
            options={noteSuggestionOptions}
            value={selectedSuggestionOrderId}
            placeholder={t("kiosk_choose_answer").message || "Choose Answer"}
            onChange={this.onChangeDropdown}
          />
        )}
        <textarea
          id="OrderEditParkingNote"
          className="OrderEditParkingNote"
          value={parkingNote}
          placeholder={t("kiosk_enter_your_parking_location").message || "Enter your parking location"}
          disabled={true}
        />
        <VirtualKeyboard onChange={this.onChange} text={parkingNote} layout={LAYOUTS.FULL} initialData={parkingNote} />
      </div>
    );

    const leftButton = <NavigationButton back onClick={onGoBack} />;

    const rightButton = (
      <NavigationButton icon="check" onClick={() => onSave(parkingNote)}>
        {t("kiosk_save").message || "Save"}
      </NavigationButton>
    );

    return renderLayout({ rightButton, leftButton, content });
  }
}

export default withTranslation()(OrderEditParkingNote);
